import {createTheme} from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main: '#035506',
        },
        secondary: {
            main: '#f9a620',
            contrastText: '#ffffff'
        },
        error: {
            main: '#f44336'
        },
        warning: {
            main: '#ff9800'
        },
        info: {
            main: '#2196f3'
        },
        success: {
            main: '#4caf50'
        }
    },
});

export default theme